import React, { useState, useEffect } from 'react'
import dayjs from "dayjs"
import { useStoresWatch } from '../UseStores/UseStore';

function WatchTimer() {
  const [runtimer, setRuntimer] = useState(() => new Date())

  //zustend 스테이트 설정
  // const { watchTimersub } = useStoresWatch();


  useEffect(() => {
    const timeId = setInterval(() => tick(), 1000)
    // console.log(watchTimersub)
    //console.log(datetime)

    return () => {
      clearInterval(timeId)
      //console.log('clearInterval')
    }
  })

  const tick = (() => {
    setRuntimer(dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss').toString())
    //console.log(`실시간:${dayjs(runtimer).format('YYYY-MM-DD HHmmss')}`)
    //console.log(`시간:${(dayjs(runtimer).format('HHmmss')).toString()}`) 
    if ((dayjs(runtimer).format('HHmmss')).toString() < "080000") {
      useStoresWatch.setState({ watchTimersub: "0500" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "110000") {
      useStoresWatch.setState({ watchTimersub: "0800" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "140000") {
      useStoresWatch.setState({ watchTimersub: "1100" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "170000") {
      useStoresWatch.setState({ watchTimersub: "1400" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "200000") {
      useStoresWatch.setState({ watchTimersub: "1700" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "230000") {
      //console.log(`시간20:${Number(dayjs(runtimer).format('HHmmss'))}`) 
      useStoresWatch.setState({ watchTimersub: "2000" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "235900") {
      useStoresWatch.setState({ watchTimersub: "2300" }) //주스텐드 ture 스테이트 변경
    }
    else if ((dayjs(runtimer).format('HHmmss')).toString() < "050000") {
      useStoresWatch.setState({ watchTimersub: "0200" }) //주스텐드 ture 스테이트 변경
    }
  })
  return (
    <>
      {`${dayjs(runtimer).format('YYYY-MM-DD HH:mm:ss')}`}
    </>
  )
}


export default WatchTimer